import { SelectCore } from './SelectCore';
import { Fragment } from './Fragment';
export var SelectStmt;
(function (SelectStmt) {
    function make(root) {
        return {
            root,
            cores: [SelectCore.make()],
            orders: new Array(),
            selects: new Array(),
            params: new Map(),
            oparams: new Map(),
            fragments: new Map(),
        };
    }
    SelectStmt.make = make;
    function getSql(initial) {
        return Fragment.get(initial, initial.root);
    }
    SelectStmt.getSql = getSql;
    function getParams(initial) {
        return Array.from(initial.oparams, ([value]) => value);
    }
    SelectStmt.getParams = getParams;
    function addSelect(initial, source) {
        return { ...initial, selects: [...initial.selects, source] };
    }
    SelectStmt.addSelect = addSelect;
    function addProjection(initial, ...sources) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.project(initial.cores[initial.cores.length - 1], ...sources),
            ],
        };
    }
    SelectStmt.addProjection = addProjection;
    function addFrom(initial, source) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.from(initial.cores[initial.cores.length - 1], source),
            ],
        };
    }
    SelectStmt.addFrom = addFrom;
    function addJoin(initial, ...sources) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.join(initial.cores[initial.cores.length - 1], ...sources),
            ],
        };
    }
    SelectStmt.addJoin = addJoin;
    function addWhere(initial, ...sources) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.where(initial.cores[initial.cores.length - 1], ...sources),
            ],
        };
    }
    SelectStmt.addWhere = addWhere;
    function addGroup(initial, ...sources) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.group(initial.cores[initial.cores.length - 1], ...sources),
            ],
        };
    }
    SelectStmt.addGroup = addGroup;
    function addHaving(initial, ...sources) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.having(initial.cores[initial.cores.length - 1], ...sources),
            ],
        };
    }
    SelectStmt.addHaving = addHaving;
    function addWindow(initial, ...sources) {
        return {
            ...initial,
            cores: [
                ...initial.cores.slice(0, initial.cores.length - 1),
                SelectCore.window(initial.cores[initial.cores.length - 1], ...sources),
            ],
        };
    }
    SelectStmt.addWindow = addWindow;
    function addOrder(initial, ...sources) {
        return { ...initial, orders: [...initial.orders, ...sources] };
    }
    SelectStmt.addOrder = addOrder;
    function setLimit(initial, source) {
        return { ...initial, limit: source };
    }
    SelectStmt.setLimit = setLimit;
    function setOffset(initial, source) {
        return { ...initial, offset: source };
    }
    SelectStmt.setOffset = setOffset;
})(SelectStmt || (SelectStmt = {}));
